export default __webpack_public_path__ + "static/latitude-scam-alert-4-9d01b7f58ea61aa7778f70c7cb947611.webp";